<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/newrewardlist/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="排行榜名称">
        <el-select v-model="formModel.rankId">
          <el-option
            v-for="item in gameName"
            :key="item.id"
            :label="item.gameName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="发放时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="rankName"
        label="排行榜名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.status == 0
              ? "已拒绝"
              : scope.row.status == 1
              ? "待审核"
              : scope.row.status == 2
              ? "已发放"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="awardAmt"
        label="金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="发放时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="日期" min-width="350" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.startTime + "~" + scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        :formatter="formatterTableData"
        min-width="360"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="操作时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/newrewardlist/sh')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="text"
            @click="openAddDialog(scope.row)"
            >审核
          </el-button>
          <span v-else>{{
            scope.row.status == 2
              ? "审核通过"
              : scope.row.status == 0
              ? "拒绝"
              : ""
          }}</span>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="审核"
      :dialogService="dialogService"
      :model="dialogModel"
      :submitData="dialogData"
      @close="dialogClose"
      @success="dialogSuccess"
      :rules="dialogRules"
      labelWidth="110px"
      class="note"
    >
      <el-form-item label="审核" prop="status">
        <el-radio-group v-model="dialogModel.status">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="0">拒绝</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="80"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import APPService from "service/APPService";
import Month from "service/constant/Month";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "newrewardlist",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      time: "",
      itemId: "",
      status: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "0",
          name: "已拒绝",
        },
        {
          code: "1",
          name: "待审核",
        },
        {
          code: "2",
          name: "已发放",
        },
      ],
      gameName: [
        {
          id: "",
          gameName: "全部",
        },
      ],
      Week: [
        //周数
        {
          weekIndex: "",
          week: "全部",
          date: "",
        },
      ],
      formModel: {
        userId: "",
        status: "",
        rankId: "",
      },
      dialogModel: {
        status: "",
        remark: "",
      },
      dialogRules: {
        status: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      tableData: [],
      submitService: APPService.newrewardlistList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        status: this.formModel.status,
        rankId: this.formModel.rankId,
        userId: this.formModel.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        params.startTime = this.time[0];
        params.endTime = this.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        status: this.dialogModel.status,
        remark: this.dialogModel.remark,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return APPService.newrewardlistSH;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {},
  methods: {
    setMonthWeek() {
      this.Week = [
        {
          weekIndex: "",
          week: "全部",
          date: "",
        },
      ];
    },
    load() {
      this.formModel = {
        rankId: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getgameName();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      this.$refs.formDialog.open();
    },
    getgameName() {
      this.doLoad(
        APPService.newrankingmanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.gameName = [...this.gameName, ...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        status: "",
        remark: "",
      };
      this.itemId = "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/NewRankIng/NewRewardList.vue